import { Box, Tooltip, Typography } from '@material-ui/core';
import CircularProgress from '@/components/CircularProgress';
import { blurSelector } from '@/redux';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { IBalanceCardProps } from '@/components/Cards/CombinedStatisticsCard/components/BalanceCard/types';
import useBalanceCard from './useBalanceCard';
import useStyles from '../../styles';

const BalanceCard = ({ user }: IBalanceCardProps): JSX.Element => {
  const styles = useStyles();
  const { salary, expected, progress, helpMessage } = useBalanceCard(user);
  const isBlurred = useSelector(blurSelector);

  return (
    <Box>
      <Typography className={styles.title} component="h4">
        Salary
      </Typography>
      <Box className={styles.box}>
        <Box>
          <Box className={styles.boxWrap}>
            <Typography className={styles.text} component="span">
              Current:&nbsp;
            </Typography>
            <Typography
              className={clsx(styles.sup, { [styles.blured]: isBlurred })}
              component="span"
            >
              ${salary.toFixed(2)}
            </Typography>
          </Box>
          <Box className={clsx(styles.textMute, styles.boxWrap)}>
            <Typography className={styles.text} component="span">
              Expected:&nbsp;
            </Typography>
            <Typography
              className={clsx(styles.text, { [styles.blured]: isBlurred })}
              component="span"
            >
              ${expected.toFixed(2)}
              {!!user.overTimePercent && (
                <Tooltip title={helpMessage}>
                  <HelpOutlineIcon className={styles.helpIcon} />
                </Tooltip>
              )}
            </Typography>
          </Box>
        </Box>
        <Box className={styles.progressBar}>
          <CircularProgress value={progress} size={52} />
        </Box>
      </Box>
    </Box>
  );
};

export default BalanceCard;
